webpackJsonp([164619872092284],{

/***/ 370:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Church Services | Killasser Parish","author":"Kingluddite"}},"contentfulNewsletter":{"title":"Killasser/Callow Parish Newsletter","slug":"newsletter","metaDescription":"newsletter filled with information about the church","headerBackgroundImage":{"file":{"url":"//images.ctfassets.net/6rnd0h65xc7e/6NHL5TRbc4S0iOQGg8AkcS/6c2c78e4e7eb5a2a506867db4ce0e348/art-cathedral-christ-cropped.jpg"}},"sectionFourHeading":"This Weeks Events","sectionFourContent":{"childMarkdownRemark":{"html":"<h2>Newletters Past and Present</h2>\n<p><a href=\"https://killasserparish.wordpress.com/\" title=\"Link to all Newsletters\">Link to all Newsletters</a></p>"}}}},"pathContext":{"slug":"/newsletter/","langKey":"en-US"}}

/***/ })

});


// WEBPACK FOOTER //
// path---newsletter-5d701f8cee66aa2cf4f3.js